export default {
  productPageNotFoundError: {
    id: 'product_page_not_found_error',
    defaultMessage: 'Product not found',
  },
}
